import React from 'react';
import './mission.css';

const OurMission = () => {
  return (
    <div className="mission-container">
      <header className="mission-header">
        <h1>Our Mission</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="mission-section">
        <p>
          At E-Techno Educational and Research Society, our mission is to empower communities through education, innovation, and research. We strive to:
        </p>

        <ul className="mission-list">
          <li>
            <strong>Provide Access to Quality Education:</strong> Ensure that underprivileged individuals and communities have access to resources and opportunities for lifelong learning.
          </li>
          <li>
            <strong>Foster Innovation:</strong> Support research and development that addresses real-world challenges and contributes to societal progress.
          </li>
          <li>
            <strong>Promote Community Development:</strong> Drive initiatives that uplift and empower communities through knowledge and skills.
          </li>
        </ul>

        <p>
          Your donations help us achieve these goals, transforming lives and shaping a better future for all. Thank you for supporting our mission!
        </p>
      </section>

      <footer className="mission-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default OurMission;
